import { useTranslation } from 'react-i18next';

import clsx from 'clsx';

import Box from '@mui/material/Box';
import Container from '@mui/material/Container';

import styles from './NotFound.module.scss';

const CandidateNotFound = () => {
  const { t } = useTranslation(['candidate', 'candidate_recruiter']);

  return (
    <div className={styles.wrapper}>
      <Container className={clsx('tag-ds', styles.container)}>
        <Box textAlign="left">
          <img src="/images/not-found/not-found.png" alt="404" />
          <h2>{t('candidate_recruiter:GENERAL.GENERIC.candidateNotFound.title')}</h2>
          <p className={clsx('large', styles.description)}>
            {t('candidate_recruiter:GENERAL.GENERIC.candidateNotFound.description')}{' '}
          </p>
        </Box>
      </Container>
    </div>
  );
};

export default CandidateNotFound;
